export const BLEND_MODE = Object.freeze({
  NORMAL: 'normal',
  MULTIPLY: 'multiply',
  SCREEN: 'screen',
  OVERLAY: 'overlay',
  DARKEN: 'darken',
  LIGHTEN: 'lighten',
  COLOR_DODGE: 'color-dodge',
  COLOR_BURN: 'color-burn',
  HARD_LIGHT: 'hard-light',
  SOFT_LIGHT: 'soft-light',
  LINEAR_LIGHT: 'linear-light',
  DIFFERENCE: 'difference',
  EXCLUSION: 'exclusion',
});

export const BLEND_MODES = Object.freeze(Object.values(BLEND_MODE));

// Text effects blend their paint into the text fill rather than blending the
// whole element with the page. Keep the familiar layer modes and add Linear
// Burn, which is required by the NBA bevel reference and rendered explicitly
// because it is not a native SVG feBlend mode.
export const TEXT_EFFECT_BLEND_MODE = Object.freeze({
  ...BLEND_MODE,
  LINEAR_BURN: 'linear-burn',
});

export const TEXT_EFFECT_BLEND_MODES = Object.freeze([
  // Linear Light uses a layer renderer and is not a native SVG feBlend mode.
  ...BLEND_MODES.filter((mode) => mode !== BLEND_MODE.LINEAR_LIGHT),
  TEXT_EFFECT_BLEND_MODE.LINEAR_BURN,
]);

export function isValidBlendMode(blendMode) {
  return BLEND_MODES.includes(blendMode);
}

export function isValidTextEffectBlendMode(blendMode) {
  return TEXT_EFFECT_BLEND_MODES.includes(blendMode);
}

export function getBlendModeForDisplay(blendMode) {
  return isValidBlendMode(blendMode) ? blendMode : BLEND_MODE.NORMAL;
}

export function getElementBlendMode(blendMode) {
  const safeBlendMode = getBlendModeForDisplay(blendMode);
  return safeBlendMode === BLEND_MODE.NORMAL || safeBlendMode === BLEND_MODE.LINEAR_LIGHT
    ? null : safeBlendMode;
}
